<script>

import appConfig from '@/app.config'
import ValidationTextEditor from '../../../components/ValidationFormInputs/ValidationTextEditor'

export default {
  page: {
    title: 'ثبت تیکت جدید',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {

    ValidationTextEditor,
  },
  data() {
    return {
      items: [
        {
          text: 'مدیریت تیکت ها',
          to: { name: 'tickets' },
        },
        {
          text: 'ثبت تیکت جدید',
          active: true,
        },
      ],
      submitted: false,
      crudeForm: {
        subject: '',
        section: null,
        department: null,
        ticketable_id: null,
        priority: '',
        message: '',
        attachments: [],
      },
      form: this.crudeForm,
      rerenderComponent: false,
      departmentOptions: [],
      statusesOptions: [],
      applications: [],
      leagues: [],
      campaigns: [],
      priorityOptions: [
        {
          id: 1,
          name: 'کم',
        },
        {
          id: 2,
          name: 'متوسط',
        },
        {
          id: 3,
          name: 'زیاد',
        },
      ],
      sectionOptions: [],
      editorToolbar: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        { name: 'forms', groups: ['forms'] },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        {
          name: 'paragraph',
          groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
        },
        { name: 'links', groups: ['links'] },
        { name: 'tools', groups: ['tools'] },
      ],
      messages: [],
      ticket: {},
      showForm: true,
      messagesPage: 1,
      isDateEnded: false,
    }
  },
  computed: {
    isEditing() {
      return this.id != undefined && this.id != null
    },
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
    id() {
      return this.$route.params.id
    },
    title() {
      return this.isEditing ? 'ارسال پاسخ جدید' : 'ثبت تیکت جدید'
    },
    user() {
      return this.$store.state.auth.user
    },
    allowSendMessage() {
      if (!this.isEditing) return true
      if (this.ticket.ticket_status_id != 4) return true
      return this.user.is_admin
    },
  },
  watch: {
    '$route.fullPath': {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.resetForm()
      },
    },
    'form.section': {
      immediate: true, // Immediate option to call watch handler on first mount
      handler() {
        this.form.ticketable_id = null
      },
    },
  },
  mounted() {
    if (this.isEditing) {
      this.showForm = false
      this.fetchRecord()
    } else {
      this.fetchMetaData()
    }
    const app = this
    window.onscroll = function() {
      if (app.isEditing) {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
          if (!app.isDateEnded) {
            app.fetchMessages()
          }
        }
      }
    }
  },
  destroyed() {
    window.addEventListener('scroll', function() {})
  },
  methods: {
    fetchMetaData() {
      this.$axios.get(`tickets/meta-data`).then((res) => {
        this.departmentOptions = res.data.departments
        this.sectionOptions = res.data.sections
        this.statusOptions = res.data.statuses
        this.applications = res.data.applications
        this.campaigns = res.data.campaigns
        this.leagues = res.data.leagues

        if (this.isEditing) {
          this.fetchMessages()
        }
      })
    },
    fetchRecord() {
      this.$axios.get(`tickets/${this.id}`).then((res) => {
        this.ticket = res.data
        this.fetchMessages()
      })
    },
    fetchMessages() {
      this.$axios
        .get(`tickets/${this.id}/messages?page=${this.messagesPage}`)
        .then((res) => {
          this.messages.push(...res.data.data)
          if (res.data.data.length === 0) this.isDateEnded = true
          this.messagesPage++
        })
    },
    submitForm() {
      const data = JSON.parse(JSON.stringify(this.form))
      if (this.isEditing) {
        this.updateRecord(data)
      } else {
        data.department_id = this.form.department.id
        data.ticket_section_id = this.form.section.id
        data.priority = this.form.priority.id
        data.ticketable_id = this.form.ticketable_id.id
        this.createRecord(data)
      }
    },
    createRecord(data) {
      this.$axios.post(`tickets`, data).then((res) => {
        this.$swal
          .fire('موفق!', `تیکت با موفقیت ایجاد شد`, 'success')
          .then(() => {
            this.$router.push({ name: 'tickets' })
          })

        this.$store.dispatch('tables/addNewItem', {
          key: 'tickets',
          item: res.data,
        })
      })
    },
    updateRecord(data) {
      this.$axios
        .post(`tickets/${this.ticket.id}/messages`, data)
        .then((res) => {
          this.$swal.fire('موفق!', `پیام شما با موفقیت ارسال شد`, 'success')

          this.messages.unshift(res.data)
        })
    },
    resetForm() {
      this.rerenderComponent = true
      const app = this
      this.$nextTick(function() {
        app.form = app.crudeForm
        app.rerenderComponent = false
      })
    },
  },
}
</script>

<template>
  <Layout v-if="!rerenderComponent">
    <PageHeader :items="items" />
    <div v-if="id === undefined || ticket.id">
      <b-alert
        :variant="notification.type === 'success' ? 'success' : 'danger'"
        class="mt-3"
        v-if="notification.message"
        @dismissed="notification.message = null"
        show
        dismissible
        >{{ notification.message }}
      </b-alert>
      <div class="row px-0">
        <div class="col-12 px-0">
          <div v-if="isEditing && ticket.id" class="card px-0">
            <div class="card-body">
              <div class="row">
                <span class="col-12 col-md-4">
                  <span
                    class="bg-primary rounded-circle"
                    style="width: 12px;height: 12px;display: inline-block"
                  ></span>
                  <strong class="pl-2 mr-1">موضوع:</strong>
                  {{ ticket.subject }}
                </span>
                <span class="col-12 col-md-4 mt-4 mt-md-0">
                  <span
                    class="bg-warning rounded-circle"
                    style="width: 12px;height: 12px;display: inline-block"
                  ></span>
                  <strong class="pl-2 mr-1">دپارتمان:</strong>
                  {{ ticket.department.name }}
                </span>
                <span class="col-12 col-md-4 mt-4 mt-md-0">
                  <span
                    class="bg-danger rounded-circle"
                    style="width: 12px;height: 12px;display: inline-block"
                  ></span>
                  <strong class="ml-2 mr-1">بخش مربوطه:</strong>
                  {{ ticket.ticket_section.name }}
                </span>
                <span class="col-12 col-md-4 mt-4 mt-md-6">
                  <span
                    class="bg-danger rounded-circle"
                    style="width: 12px;height: 12px;display: inline-block"
                  ></span>
                  <strong class="ml-2 mr-1">رکورد مربوطه:</strong>
                  {{ ticket.ticketabl ? ticket.ticketable.name : '--------' }}
                </span>
                <span class="col-12 col-md-4 mt-4 ">
                  <span
                    class="bg-success rounded-circle"
                    style="width: 12px;height: 12px;display: inline-block"
                  ></span>
                  <strong class="pl-2 mr-1">اولویت:</strong>
                  <span v-if="ticket.priority === 1">کم</span>
                  <span v-if="ticket.priority === 2">متوسط</span>
                  <span v-if="ticket.priority === 3">زیاد</span>
                </span>
                <span class="col-12 col-md-3 mt-4">
                  <span
                    class="bg-primary rounded-circle"
                    style="width: 12px;height: 12px;display: inline-block"
                  ></span>
                  <strong class="pl-2 mr-1">وضعیت:</strong>
                  <span
                    class="mr-2"
                    :class="{
                      'text-warning': ticket.ticket_status_id === 1,
                      'text-success': ticket.ticket_status_id === 2,
                      'text-primary': ticket.ticket_status_id === 3,
                      'text-danger': ticket.ticket_status_id === 4,
                    }"
                    >{{ ticket.ticket_status.name }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <b-alert v-if="!allowSendMessage" variant="danger" class="mt-3" show
            >این تیکت بسته شده است و امکان ارسال پاسخ وجود ندارد
          </b-alert>
          <div class="card px-0" v-if="allowSendMessage">
            <div class="card-body">
              <h4 v-if="!isEditing">{{ title }}</h4>
              <div
                v-if="isEditing"
                @click="showForm = !showForm"
                style="cursor: pointer"
                class="d-flex justify-content-between align-items-center"
              >
                <h4>{{ title }}</h4>
                <button class="btn" v-if="isEditing">
                  <i
                    v-show="!showForm"
                    class="ri-arrow-down-line"
                    style="font-size: 1rem"
                  ></i>
                  <i
                    v-show="showForm"
                    class="ri-arrow-up-line"
                    style="font-size: 1rem"
                  ></i>
                </button>
              </div>
              <ValidationObserver
                v-show="showForm"
                v-slot="{ handleSubmit }"
                tag="div"
              >
                <form
                  class="needs-validation"
                  @submit.prevent="handleSubmit(submitForm)"
                >
                  <div class="row">
                    <template v-if="!isEditing">
                      <div
                        :class="{
                          'col-md-3': form.section != null,
                          'col-md-4': form.section == null,
                        }"
                      >
                        <validation-select
                          :options="departmentOptions"
                          v-model="form.department"
                          validation-field-name="دپارتمان"
                          option-value-key="id"
                          option-text-key="name"
                          label="دپارتمان"
                          rules="required"
                        >
                        </validation-select>
                      </div>
                      <div
                        :class="{
                          'col-md-3': form.section != null,
                          'col-md-4': form.section == null,
                        }"
                      >
                        <validation-select
                          :options="sectionOptions"
                          v-model="form.section"
                          validation-field-name="بخش"
                          option-value-key="id"
                          option-text-key="name"
                          label="بخش"
                          rules="required"
                        >
                        </validation-select>
                      </div>
                      <div
                        :class="{
                          'col-md-3': form.section != null,
                          'col-md-4': form.section == null,
                        }"
                        v-if="form.section && form.section.id == 1"
                      >
                        <validation-select
                          :options="applications"
                          v-model="form.ticketable_id"
                          validation-field-name="اپلیکیشن مربوطه"
                          option-value-key="id"
                          option-text-key="name"
                          label="اپلیکیشن مربوطه"
                          rules="required"
                        >
                        </validation-select>
                      </div>
                      <div
                        :class="{
                          'col-md-3': form.section != null,
                          'col-md-4': form.section == null,
                        }"
                        v-if="form.section && form.section.id == 2"
                      >
                        <validation-select
                          :options="campaigns"
                          v-model="form.ticketable_id"
                          validation-field-name="کمپین مربوطه"
                          option-value-key="id"
                          option-text-key="name"
                          label="کمپین مربوطه"
                          rules="required"
                        >
                        </validation-select>
                      </div>
                      <div
                        :class="{
                          'col-md-3': form.section != null,
                          'col-md-4': form.section == null,
                        }"
                        v-if="form.section && form.section.id == 3"
                      >
                        <validation-select
                          :options="leagues"
                          v-model="form.ticketable_id"
                          validation-field-name="لیگ مربوطه"
                          option-value-key="id"
                          option-text-key="name"
                          label="لیگ مربوطه"
                          rules="required"
                        >
                        </validation-select>
                      </div>
                      <div
                        :class="{
                          'col-md-3': form.section != null,
                          'col-md-4': form.section == null,
                        }"
                      >
                        <validation-select
                          :options="priorityOptions"
                          v-model="form.priority"
                          validation-field-name="اولویت"
                          option-value-key="id"
                          option-text-key="name"
                          label="اولویت"
                          rules="required"
                        >
                        </validation-select>
                      </div>
                      <div class="col-md-12">
                        <validation-input
                          v-model="form.subject"
                          type="text"
                          placeholder="موضوع"
                          rules="required"
                          validation-field-name="موضوع"
                          label="موضوع"
                        ></validation-input>
                      </div>
                    </template>
                    <div class="col-12 mt-4">
                      <validation-text-editor
                        rules="required"
                        :upload-image="false"
                        :toolbar="editorToolbar"
                        label="پیام"
                        validation-field-name="پیام"
                        v-model="form.message"
                      ></validation-text-editor>
                    </div>
                    <div class="col-12 mt-4">
                      <validation-file-upload
                        v-model="form.attachments"
                        :options="{ maxFiles: 10 }"
                        label="ضمیمه ها"
                        file-type="file"
                        accepted-files="audio/*,image/*,.pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .rtf, .html, .zip,.rar"
                      >
                      </validation-file-upload>
                    </div>
                  </div>
                  <button
                    class="btn btn-primary mt-4"
                    style="float: left"
                    type="submit"
                  >
                    {{ id !== undefined ? 'ثبت پاسخ' : 'ثبت تیکت' }}
                  </button>
                </form>
              </ValidationObserver>
            </div>
          </div>
          <div class="card px-0">
            <div class="card-body">
              <div v-for="(message, i) in messages" :key="i" class="mt-4 pt-4">
                <div class="flex items-center gap-2">
                  <i class="bx bx-user text-xl"></i>
                  <template v-if="message.admin_id === null">
                    <span style="font-size: 0.7rem;display:inline-block"
                      >{{ ticket.user.name }} {{ ticket.user.lname }}</span
                    >
                    <span
                      style="font-size: 0.7rem;display:inline-block"
                      class="bg-primary text-white rounded-lg py-1 px-3 ml-2"
                      >کاربر</span
                    >
                  </template>
                  <template v-else>
                    <span style="font-size: 0.7rem" class="text-sm"
                      >{{ message.admin.name }} {{ message.admin.family }}</span
                    >
                    <span
                      style="font-size: 0.7rem;display:inline-block"
                      class="text-sm bg-success text-white rounded-lg py-1 px-3 ml-2"
                      >اپراتور</span
                    >
                  </template>
                  <span style="font-size: 0.7rem" class="text-sm ml-2">{{
                    message.created_at
                  }}</span>
                </div>
                <div class="rounded-xl p-4 mt-4" style="background: #fafafa">
                  <div v-html="message.message"></div>
                  <hr
                    v-if="message.attachments.length > 0"
                    class="w-full mt-4"
                  />
                  <div class="mt-4 gap-4 flex">
                    <a
                      v-for="(attachment, y) in message.attachments"
                      :key="y"
                      class="text-sm mx-2 hover:text-primary inline-block"
                      :href="attachment.url"
                      target="_blank"
                      >ضمیمه {{ y + 1 }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
